import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import HomeScreen from './HomeScreen';
import TermsScreen from './TermsScreen';
import PrivacyScreen from './PrivacyScreen';
import ContactScreen from './ContactScreen';


function Header() {
  const location = useLocation();

  return (
    <header className="app-header">
      <div className="logo">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <h2>ActivoLog</h2>
        </Link>
      </div>
      <nav className="nav-buttons">
        <Link to="/" className={`nav-btn ${location.pathname === '/' ? 'active' : ''}`}>
          Home
        </Link>
        <Link to="/term_and_condition" className={`nav-btn ${location.pathname === '/term_and_condition' ? 'active' : ''}`}>
          Terms & Conditions
        </Link>
        <Link to="/privacy_policy" className={`nav-btn ${location.pathname === '/privacy_policy' ? 'active' : ''}`}>
          Privacy Policy
        </Link>
        <Link to="/contact_us" className={`nav-btn ${location.pathname === '/contact_us' ? 'active' : ''}`}>
          Contact Us
        </Link>
      </nav>
    </header>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/term_and_condition" element={<TermsScreen />} />
            <Route path="/privacy_policy" element={<PrivacyScreen />} />
            <Route path="/contact_us" element={<ContactScreen />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
